import type { ComponentProps } from 'react';
import { memo } from 'react';

import defaultAvatar from '@/assets/img/default-avatar.png';
import { AceBadge } from '@/features/subscription/components/aceBadge';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/shared/components/ui/avatar';
import { cn } from '@/shared/utils/cn';

export interface ProfileOverviewCardAvatarProps extends Omit<
  ComponentProps<'div'>,
  'children'
> {
  pictureUrl: string;
  isPremium?: boolean;
  alt?: string;
}

export const ProfileOverviewCardAvatar = memo(
  function ProfileOverviewCardAvatar({
    pictureUrl,
    isPremium,
    alt = 'Player',
    className,
    ...props
  }: ProfileOverviewCardAvatarProps) {
    return (
      <>
        <Avatar
          className={cn(
            'pointer-events-none h-full w-full rounded-none bg-white/20 shadow-sm shadow-black/5',
            className,
          )}
          {...props}
        >
          <AvatarFallback className="rounded-none">
            <img
              src={defaultAvatar}
              alt="Default avatar"
              className="size-full object-cover"
            />
          </AvatarFallback>
          <AvatarImage
            className="h-full w-full object-cover"
            src={pictureUrl}
            alt={alt}
          />
        </Avatar>

        {isPremium && (
          <AceBadge className="absolute top-0 left-1/2 z-1 -translate-x-1/2 rounded-tl-none rounded-tr-none rounded-b-xl border-4 border-t-0 border-yellow-600 bg-linear-to-r from-yellow-300 to-yellow-500" />
        )}
      </>
    );
  },
);
